module.exports = __webpack_public_path__ + "static/media/check.49e6852f.svg";